<div
  class="d-inline-flex align-items-start flex-column input-text-sizing"
  [formGroup]="parentFormGroup"
>
  <div class="field-label" *ngIf="formElementModel.label">
    {{ formElementModel.label + asterisk }}
  </div>
  <mat-form-field
    [ngClass]="{ 'editor inline-editable-editor': !control.disabled }"
    floatLabel="auto"
    [aria-label]="formElementModel.label ? formElementModel.label : ''"
    ><mat-select
      [formControlName]="formElementModel.id"
      [disableOptionCentering]="true"
      tabIndex="0"
    >
      <mat-option
        *ngFor="let option of formElementModel.options"
        [value]="option.key"
        >{{ option.value }}</mat-option
      >
    </mat-select>
  </mat-form-field>
  <app-validation-error
    [control]="control"
    [formElementModel]="formElementModel"
  ></app-validation-error>
</div>
